//TODO needs pagination

// Libraries
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from '../../../routes/routes';
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../../helpers/util"


// Redux
import { functionalityActions, notificationTypeActions } from 'actions';

// Components
import { Table } from "../../../components/SkyFramework/Tables/Table";
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../../components/SkyFramework/Search";
import { PaginationBar } from "../../../components/SkyFramework/Pagination/PaginationBar.jsx";

// Constants
const phrasebook = phrasebookLoad()

class NotificationTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account_types: undefined,
      functionalities: undefined,
      notificationtypes: undefined,
      account_type_id: undefined,
      functionality_id: undefined,
      filters: { orderby: 'functionality_id', asc: true },
      limit: 10,
      page: 1
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
  }

  componentDidMount() {

    this.props.dispatch(functionalityActions.getAll(0, 0, { notification: true }));
    this.props.dispatch(notificationTypeActions.getAll(this.state.limit, 0, this.state.filters));
  }

  componentDidUpdate(prevProps) {
    if (this.props.functionalities && prevProps && prevProps.functionalities !== this.props.functionalities) {
      this.setState({ functionalities: this.props.functionalities });
    }
    if (this.props.notificationtypes && prevProps && prevProps.notificationtypes !== this.props.notificationtypes) {
      this.setState({ notificationtypes: this.props.notificationtypes });
    }
  }

  onSelectChange = (e) => {
    const { value, name } = e.target;
    if (value) {
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: undefined });
    }
  }
  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    var searchValues = {
      functionality_id: this.state.functionality_id,
      orderby: 'functionality_id', asc: true
    }
    this.setState({ filters: searchValues });
    this.props.dispatch(notificationTypeActions.getAll(this.state.limit, 0, searchValues));
  }

  handleDeleteSubmit = (event) => {
    const { id } = event.target;
    this.props.dispatch(notificationTypeActions.deletePermission(id));
  }


  onPageChanged = currentPage => {
    this.setState({ page: currentPage });
    this.props.dispatch(notificationTypeActions.getAll(this.state.limit, currentPage - 1, this.state.filters));
  }

  SearchBox() {
    var filters = []
    if (this.state.functionalities) {

      const functionalitiesOptions = [];
      this.state.functionalities.data.map(function (functionality) {
        if ((token.loggedAccountType() >= 200 && functionality.customercrud && functionality.customercrud.length > 0) || (token.loggedAccountType() < 200 && functionality.pccwglobalcrud && functionality.pccwglobalcrud.length > 0)) {
          functionalitiesOptions.push({ value: functionality['id'], label: `${capitalizeFirstLetter(functionality['description'])}` });
        }

      });
      filters.push([{ label: phrasebook.headerlinks.functionality, type: "select", id: "functionality_id", tooltip: 'Type of function to give permission', name: "functionality_id", options: functionalitiesOptions, empty_option: true }])
      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else return null;
  }
  canAdd() {
    if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.administration.permission, permissionTypeConst.ADD, token.loggedToken())) return <div class="ml-sm-auto mt-1 mt-sm-0"><Link to={gisRoutes.administration.notification_type.add}>
      <button type="button" class="btn btn-main">
        {phrasebook.common.add} {phrasebook.common.permission_type}
      </button>
    </Link>
    </div>
  }

  NotificationTypes = () => {
    if (this.state.notificationtypes) {
      let labels = [
        phrasebook.headerlinks.category,
        phrasebook.common.status,
        phrasebook.alerts.default_account_type_receiver,

      ];
      this.state.notificationtypes.data.forEach((notificationtype, index) => {
        let default_receivers = []
        notificationtype.default_receiver_account_type_id.forEach(account => {
          default_receivers.push(accountTypesConstants[parseInt(account)]);
        })
        this.state.notificationtypes.data[index].default_receiver_account_types = default_receivers;
      })
      var fields = [['functionality', 'description'], 'action', 'default_receiver_account_types']
      var actions = [];
      if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.administration.permission, permissionTypeConst.EDIT, token.loggedToken())) actions.push({
        location: gisRoutes.administration.notification_type.edit,
        label: phrasebook.common.edit,
        type: 'link'
      });
      // if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.administration.permission, permissionTypeConst.DELETE, token.loggedToken())) actions.push({
      //   location: gisRoutes.administration.notification_type.delete,
      //   label: phrasebook.common.delete,
      //   type: 'action',
      //   onClick: this.handleDeleteSubmit
      // })
      return (<>
        {/* {this.canAdd()} */}
        <br></br>
        <Table
          values={this.state.notificationtypes.data}
          limit={this.state.limit}
          currentPage={this.state.page}
          pageNeighbours={this.state.pageNeighbours}
          onPageChanged={this}
          nofound={phrasebook.common.nodatafound}
          headers={labels}
          keys={fields}
          actions={actions}
          action_key={'id'}
        />
        <PaginationBar limit={this.state.limit}
          total={this.state.notificationtypes.count}
          currentPage={this.state.page}
          onPageChanged={this}
          pageNeighbours={this.state.pageNeighbours} />
      </>)
    } else return null;
  }

  render = () => {
    const { permission } = this.props;
    if (permission) {
      this.state.permission = permission;
    }
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.headerlinks.notification_types} />

      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.notification_types} {phrasebook.headerlinks.configuration}</h2>
        {this.SearchBox()}
      </div>
      <div className="box p-1 p-sm-2 my-md-1">
        <h3 className="box-title pb-1 mb-1">{phrasebook.headerlinks.notification_types}</h3>
        {this.NotificationTypes()}
      </div>
    </>
  }
}

function mapStateToProps(state) {
  const { loggedpermissions, account, authentication, functionality, notificationtype } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    account_types: account.account_types,
    functionalities: functionality.functionalities,
    notificationtypes: notificationtype.notificationtypes
  };
}

const notificationtypes = connect(mapStateToProps)(NotificationTypes);

//export default withStyles(styles)(partnersite);
export default (notificationtypes);
